<template>
  <!-- Title -->
  <h1>Unsplash API - Infinite Scroll</h1>
  <!-- Loader -->
  <div class="loader" id="loader">
    <img src="@/assets/loader.svg" alt="Loading" />
  </div>
  <!-- Image Container -->
  <div class="image-container" id="image-container"></div>
</template>

<script>
export default {
  name: "App",
  components: {},

  mounted() {
    const imageContainer = document.getElementById("image-container");
    const loader = document.getElementById("loader");

    let ready = false;
    let imagesLoaded = 0;
    let totalImages = 0;
    let photosArray = [];

    // Unsplash API
    const count = 30;
    const apiKey = process.env.VUE_APP_UNSPLASH_API_KEY;
    const query = "girl in nature";
    const apiUrl = `https://api.unsplash.com/photos/random?client_id=${apiKey}&count=${count}&query=${query}`;

    // Check if all images were loaded
    function imageLoaded() {
      imagesLoaded++;
      if (imagesLoaded === totalImages) {
        ready = true;
        loader.hidden = true;
      }
    }

    // Helper Function to Set Attributes on DOM Elements
    function setAttributes(element, attributes) {
      for (const key in attributes) {
        element.setAttribute(key, attributes[key]);
      }
    }

    // Create Elements For Links & Photos, Add to DOM
    function displayPhotos() {
      imagesLoaded = 0;
      totalImages = photosArray.length;
      // Run function for each object in photosArray
      photosArray.forEach((photo) => {
        // Create <a> to link to full photo
        const item = document.createElement("a");
        setAttributes(item, {
          href: photo.links.html,
          target: "_blank",
        });
        // Create <img> for photo
        const img = document.createElement("img");
        setAttributes(img, {
          src: photo.urls.regular,
          alt: photo.alt_description,
          title: photo.alt_description,
        });
        // Event Listener, check when each is finished loading
        img.addEventListener("load", imageLoaded);
        // Put <img> inside <a>, then put both inside imageContainer Element
        item.appendChild(img);
        imageContainer.appendChild(item);
      });
    }

    // Get photos from Unsplash API
    async function getPhotos() {
      try {
        const response = await fetch(apiUrl);
        photosArray = await response.json();
        displayPhotos();
      } catch (error) {
        // Catch Error Here
      }
    }

    // Check to see if scrolling near bottom of page, Load More Photos
    window.addEventListener("scroll", () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 1000 &&
        ready
      ) {
        ready = false;
        getPhotos();
      }
    });

    // On Load
    getPhotos();
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
